export default "__VITE_ASSET__Bx47dFmb__"